import "moment/locale/fr";
import "moment/locale/it";
import "moment/locale/nl";
import "moment/locale/es";
import "moment/locale/de";
import moment from 'moment';
import "moment/locale/en-gb";
import { T, LANG, TB } from '../Constants';

const getInitialLang = () => {
    // Get the language from the local storage
    let prop = localStorage.getItem("lang") as T.LanguageProps;
    let lang_index = LANG.ALL_LANGUAGES.find(l => l.prop === prop)?.index;
    // The stored language is not an accepted value
    if (!LANG.ALL_PROPS.includes(prop)) {
        // Set the default language
        prop = LANG.FR_PROP;
        lang_index = LANG.FR;
        localStorage.setItem("lang", prop);
    }
    // Update the language in the html document
    const lang_html_code = LANG.getHtmlLanguageCode(lang_index);
    document.documentElement.setAttribute("lang", lang_html_code);
    // Update the moment locale
    moment.locale(LANG.MOMENT_LOCAL(lang_index));
    // Return the initial state
    return lang_index;
}

const languageRedux: T.ReduxFn<number, T.LanguageActions, number> = (state = getInitialLang(), payload) => {
    const { type, action } = TB.getObject(payload);

    if (type === "CHANGE_LANG") {
        // Provided language is not valid, don't change anything
        if (TB.getValidLanguageCode(action) !== action) return state;
        // Update the language in the local storage and the html element
        const lang_prop = LANG.ALL_LANGUAGES.find(l => l.index === action)?.prop || LANG.FR_PROP;
        document.documentElement.setAttribute("lang", LANG.getHtmlLanguageCode(action));
        localStorage.setItem("lang", lang_prop);
        // Update the moment locale
        moment.locale(LANG.MOMENT_LOCAL(action));
        // Update the state
        return action;
    }
    else return state;
}

export default languageRedux;

export const setLanguage: T.ReduxDispatch<T.LanguageActions, number> = lang => ({ type: "CHANGE_LANG", action: lang });